module.exports = __webpack_public_path__ + "static/media/contact.9e0638fa.jpg";